module.exports = __webpack_public_path__ + "static/img/gaganbo_rui.681c1e3.jpg";